var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0001 19L13.0001 7.135L17.3601 10.768C17.7841 11.122 18.4151 11.064 18.7681 10.64C19.1221 10.215 19.0641 9.585 18.6401 9.232L12.6401 4.232C12.5931 4.193 12.5381 4.173 12.4861 4.144C12.4441 4.12 12.4081 4.091 12.3621 4.073C12.2471 4.028 12.1261 4.001 12.0041 4.001C12.0031 4.001 12.0011 4 12.0001 4C11.9991 4 11.9971 4.001 11.9961 4.001C11.8741 4.001 11.7531 4.028 11.6381 4.073C11.5921 4.091 11.5561 4.12 11.5141 4.144C11.4621 4.173 11.4071 4.193 11.3601 4.232L5.36009 9.232C5.12309 9.43 5.00009 9.714 5.00009 10C5.00009 10.226 5.07609 10.453 5.23209 10.64C5.58509 11.064 6.21609 11.122 6.64009 10.768L11.0001 7.135L11.0001 19C11.0001 19.552 11.4481 20 12.0001 20C12.5521 20 13.0001 19.552 13.0001 19Z",
    fill: "#F8F9FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.3a699ad54c0cd3af75bf9ce77de789c2.svg";
export { ForwardRef as ReactComponent };